(ns iris.homepage.views
  (:require
   [iris.subs :as subs]
   [iris.common :as common]
   [shadow.css :refer (css)]))



(defn homepage-panel []
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     [:p {:class (css :px-4 :py-8 :underline :font-bold {:color "blue"} [:hover {:color "red"}])
          :style {:margin "10px"}} "Page Views report has moved to Analytics section. "
      [:a {:href "/analytics/page-views"} "Click here"] " to be redirected."]
     [common/message ::subs/message]])